// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gridbtntop .customSelect {\n  padding-bottom: 0px !important;\n}\n.gridbtntop .customSelect .q-field__inner {\n  padding-bottom: 0px !important;\n}\n.gridbtntop .customSelect .q-field__control, .gridbtntop .customSelect .customSelect.q-field--dense .q-field__marginal {\n  height: 24px !important;\n  min-height: 24px !important;\n}", ""]);
// Exports
module.exports = exports;
